/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FolderOutlined, PlusCircleFilled, ExclamationCircleOutlined, DeleteTwoTone, FileDoneOutlined, FileImageOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { FaRegFilePdf } from "react-icons/fa";
import { clientScreenHandle } from "./state/actions";
import { Button, Input, Modal, Spin, Upload, message, Typography, Image, Checkbox } from "antd";
import { useRef } from "react";
import confirm from "antd/lib/modal/confirm";
import styles from "./styles/ClientScreen.module.css";
import { EmptyData } from "../Common/components/EmptyData";
import { useMediaQuery } from "react-responsive";
import { changeExtensiontoLowerCase, getPreSignedUrls, uploadFileToS3 } from "../Common/utils/extraFunctions";
import { Loading } from "../Common/components/Loading";
const { Text } = Typography;

const EmailFile = () => {
  const [isHovered, setIsHovered] = useState(null);
  const [isHovered2, setIsHovered2] = useState(null);
  const { emailFilesData, emailFilesLoading, propertUploadDocs, propertDocsLoading } = useSelector((state) => state.clientScreen);
  const { getUserDetailsData } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 420 });
  const convertTimestampToMMDDYYYY = (timestamp) => {
    let date = moment(timestamp).format("MM/DD/YYYY");
    return date;
  };

  const convertTimestampTotime = (timestamp) => {
    const currentTime = moment(timestamp).format("h:mm A");
    return currentTime;
  };

  useEffect(() => {
    let data = {
      role: getUserDetailsData?.openFor,
      _id: getUserDetailsData?._id,
      propertyId: getUserDetailsData?.propertyId,
      offerId: getUserDetailsData?.offerId,
    };
    dispatch(clientScreenHandle.EmailFileData(data));
  }, []);

  useEffect(() => {
    const params = {
      ...(getUserDetailsData?.offerId ? { offerId: getUserDetailsData?.offerId } : {}),
      ...(getUserDetailsData?._id ? { personId: getUserDetailsData?._id } : {}),
      ...(getUserDetailsData?.propertyId ? { propertyId: getUserDetailsData?.propertyId } : {}),
      openFor: getUserDetailsData?.openFor,
    };

    dispatch(clientScreenHandle.getPropertyDocsFun(params));
  }, []);

  const [allFiles, setAllFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrl, setPreviewUrl] = useState([]);
  const [fileText, setFileText] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showInputFileName, setShowInputFileName] = useState(false);

  function bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }
  const selectedSizeMB = allFiles.filter((_, idx) => selectedFiles.includes(idx)).reduce((acc, file) => acc + file.size, 0) / (1024 * 1024);

  const isTooBig = selectedSizeMB > 100;
  const handleCustome = ({ file, onSuccess }) => {
    const fileIndex = allFiles.length;

    setAllFiles((prev) => [...prev, file]);
    setSelectedFiles((prev) => [...prev, fileIndex]); // Mark this file as selected by default
    setPreviewUrl((prev) => [...prev, URL.createObjectURL(file)]);
    setFileText((prev) => [...prev, { name: file.name, size: bytesToSize(file.size) }]);
    setShowInputFileName(true);

    onSuccess("ok");
  };

  const uploadTemp = async () => {
    if (selectedFiles.length === 0) return;

    try {
      setLoading(true);

      const selectedUploads = allFiles.filter((_, idx) => selectedFiles.includes(idx));
      const filenames = selectedUploads.map((file) => changeExtensiontoLowerCase(file.name));
      const presignedUrls = await getPreSignedUrls(filenames,"Client_DasBoard");

      if (!presignedUrls || presignedUrls.length !== selectedUploads.length) {
        message.error("Could not generate all upload URLs.");
        return;
      }

      const uploadedLinks = await Promise.all(
        selectedUploads.map(async (file, idx) => {
          const url = presignedUrls[idx]?.url;
          if (!url) return null;

          const uploadedUrl = await uploadFileToS3(file, url);
          if (!uploadedUrl) return null;

          return {
            fileLink: uploadedUrl,
            fileName: file.name,
            fileType: file.type.includes("image") ? "IMAGE" : "PDF",
          };
        })
      );

      const validLinks = uploadedLinks.filter(Boolean);

      if (validLinks.length) {
        const params = {
          ...(getUserDetailsData?.offerId ? { offerId: getUserDetailsData?.offerId } : {}),
          ...(getUserDetailsData?._id ? { personId: getUserDetailsData?._id } : {}),
          ...(getUserDetailsData?.propertyId ? { propertyId: getUserDetailsData?.propertyId } : {}),
          openFor: getUserDetailsData?.openFor,
          fileLinks: validLinks,
        };

        await dispatch(clientScreenHandle.uploadPropertyDocs(params));
     
      } else {
        message.error("Upload failed. No valid files were uploaded.");
      }

      // Reset file state
      setAllFiles([]);
      setSelectedFiles([]);
      setPreviewUrl([]);
      setFileText([]);

      setShowInputFileName(false);
    } catch (error) {
      message.error("Error during file upload");
    } finally {
      setLoading(false);
    }
  };

  function beforeUpload(file) {
    let supportedFormats = file?.type;

    if (supportedFormats?.includes("image")) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" || file.type === "image/webp";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG/JPEG/WEBP file!");
      }
      const isLt5M = file.size / 1024 / 1024 < 100;
      if (!isLt5M) {
        message.error("Image must smaller than 100MB!");
      }
      return isJpgOrPng && isLt5M;
    }

    if (supportedFormats?.includes("pdf")) {
      const isPdf = file.type === "application/pdf";
      if (!isPdf) {
        message.error("You can only upload PDF file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        message.error("File must be smaller than 100MB!");
      }
      return isPdf && isLt2M;
    }
  }
  const handleCancelInputFileName = () => {
    setShowInputFileName(false);
    setAllFiles([]);
      setSelectedFiles([]);
      setPreviewUrl([]);
      setFileText([]);
  };
  const handleCloseSetFileNameModalConfirm = (docId) => {
    confirm({
      title: `Are you sure you don't want to upload this document?`,
      // content: "Note: This action is irreversible. Deleting this document will permanently remove it from your account.",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        handleCancelInputFileName();
        // dispatch(propertyDataHandle.removePropertyDocsFun(docId));
      },
      onCancel() {},
    });
  };

  const handleDeleteConfirm = (docId) => {
    const params = {
      ...(getUserDetailsData?.offerId ? { offerId: getUserDetailsData?.offerId } : {}),
      ...(getUserDetailsData?.propertyId ? { propertyId: getUserDetailsData?.propertyId } : {}),
      ...(getUserDetailsData?._id ? { personId: getUserDetailsData?._id } : {}),
      openFor: getUserDetailsData?.openFor,
    };
    confirm({
      title: `Are you sure you want to delete this file?`,
      content: "Note: This action is irreversible. Deleting this file will permanently remove it from your account.",
      okText: "Yes",
      cancelText: "No",
      okType: "danger",
      icon: <ExclamationCircleOutlined style={{ color: "orange" }} />,
      onOk() {
        dispatch(clientScreenHandle.removePropertyDocsFun(docId, params));
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div style={{ width: "100%", height: "calc(100vh - 10.1rem)" }}>
        <div style={{ justifyContent: "center", display: "flex", alignItems: "center", fontWeight: "bold", width: "100%", fontSize: "18px", color: "Gray", height: "7%" }}>Emails from RE-Sure</div>

        <div style={{ display: "flex", width: "100%", backgroundColor: " #0078d4", height: "6%", color: "white", alignItems: "center", padding: "10px", position: "sticky" }}>
          <div className={styles.action2}>From</div>
          <div className={styles.action2}>Date/Time</div>
          <div className={styles.action3}>Contract Name</div>
        </div>
        {emailFilesLoading ? (
          <div style={{ width: "100%", fontSize: "15px", height: window.screen.width ? "35%" : "20%", paddingTop: "10%", textAlign: "center" }}>
            <Spin />
          </div>
        ) : (
          <div style={{ width: "100%", fontSize: "15px", height: "36%", color: "black", overflowY: "auto" }}>
            {emailFilesData ? (
              emailFilesData?.map((ele, index) => {
                const timestamp = ele.sentDateMili;
                const formattedDate = convertTimestampToMMDDYYYY(timestamp);
                const currentTime = convertTimestampTotime(timestamp);
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      backgroundColor: isHovered === index ? "rgb(132, 187, 238)" : "transparent",
                      margin: "5px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onMouseEnter={() => setIsHovered(index)}
                    onMouseLeave={() => setIsHovered(null)}
                  >
                    <div style={{ width: "25.33%", fontSize: "15px", padding: "5px", textAlign: isMobile ? "left" : "center" }}>{ele.sentBy}</div>
                    <div style={{ width: "25.33%", textAlign: isMobile ? "left" : "center" }}>
                      {formattedDate}
                      {"  "}
                      {currentTime}
                    </div>
                    <div style={{ width: "49.34%", textAlign: isMobile ? "right" : "center", marginLeft: "5px" }}>{ele.contractName}</div>
                  </div>
                );
              })
            ) : (
              <EmptyData />
            )}
          </div>
        )}
        <hr style={{ color: "#0078d4" }} />
        <div style={{ justifyContent: "center", display: "flex", alignItems: "center", fontWeight: "bold", width: "100%", fontSize: "18px", color: "Gray", height: "7%" }}>
          <div>
            <FileDoneOutlined size={25} style={{ position: "relative", fontSize: "25px", color: "#085191" }} />
          </div>
          <div style={{ paddingLeft: "10px", paddingRight: "10px", color: "Gray", fontSize: "18px" }}>Files Upload</div>
          <Upload className="borderless-button" showUploadList={false} accept="image/*,.pdf" customRequest={handleCustome} beforeUpload={beforeUpload} style={{ background: "red", marginRight: "20px", boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px" }} multiple>
            <PlusCircleFilled size={25} style={{ position: "relative", fontSize: "25px", color: "#085191", cursor: "pointer" }} />
          </Upload>
        </div>
        <div style={{ display: "flex", width: "100%", backgroundColor: " #0078d4", height: "6%", color: "white", alignItems: "center", padding: "10px", position: "sticky" }}>
          <div className={styles.action3}>File Name</div>
          <div className={styles.action2}>Date/Time</div>
          <div className={styles.action2}>Delete</div>
        </div>
        {propertDocsLoading ? (
          <div style={{ width: "100%", fontSize: "15px", height: "36%", paddingTop: "10%", textAlign: "center" }}>
            <Spin />
          </div>
        ) : (
          <div style={{ width: "100%", fontSize: "15px", height: "34.5%", color: "black", overflowY: "auto" }}>
            {propertUploadDocs.length > 0 ? (
              propertUploadDocs?.map((ele, index) => {
                const timestamp = ele.createdDateMili;
                const formattedDate = convertTimestampToMMDDYYYY(timestamp);
                const currentTime = convertTimestampTotime(timestamp);
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      backgroundColor: isHovered2 === index ? "rgb(132, 187, 238)" : "transparent",
                      margin: "5px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onMouseEnter={() => setIsHovered2(index)}
                    onMouseLeave={() => setIsHovered2(null)}
                  >
                    <a target="blank" href={ele.fileUrl} style={{ width: "49.34%", color: "black" }}>
                      <div style={{ width: "100%", padding: "5px", display: "flex", textAlign: "center" }}>
                        <div style={{ marginRight: "10px", color: "#0078d4" }}>{ele.fileType === "IMAGE" ? <FileImageOutlined style={{ fontSize: "20px", color: "red" }} /> : <FaRegFilePdf style={{ fontSize: "20px", color: "red" }} />}</div>
                        <Typography.Text style={{ width: "100%", textAlign: "center" }}>{ele.fileName}</Typography.Text>
                      </div>
                    </a>
                    <div style={{ width: "25.33%", textAlign: "center" }}>
                      <a target="blank" href={ele.fileUrl} style={{ color: "black", textAlign: "center" }}>
                        {formattedDate}
                        {"  "}
                        {currentTime}
                      </a>
                    </div>
                    <div style={{ width: "25.33%", textAlign: "center", cursor: "pointer", fontSize: "20px" }} onClick={() => handleDeleteConfirm(ele._id)}>
                      <DeleteTwoTone />
                    </div>
                  </div>
                );
              })
            ) : (
              <EmptyData />
            )}
          </div>
        )}
      </div>

      {/* Modal to add Input file Name */}
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              color: "grey",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            Upload Files
          </div>
        }
        footer={
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }} key="footer">
            {isTooBig && (
              <Text type="danger" style={{ textAlign: "center", display: "block", marginBottom: "10px" }}>
                Total selected image size exceeds 100MB. Please unselect some files.
              </Text>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <span>
                <strong>Total Size:</strong> {selectedSizeMB.toFixed(2)} MB
              </span>
              <div style={{ marginTop: "20px", textAlign: "center" }} wrapperCol={{ offset: 0, span: 24 }}>
                <Button type="primary" onClick={uploadTemp} style={{ marginRight: "10px" }} disabled={selectedFiles.length === 0 || isTooBig}>
                  OK
                </Button>
                <Button type="default" onClick={handleCancelInputFileName}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        }
        open={showInputFileName}
        onCancel={handleCloseSetFileNameModalConfirm}
        maskClosable={!loading}
        closable={!loading}
      >
        {loading ? (
          <Loading />
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", maxHeight: "55vh", overflowY: "auto", padding: "10px" }}>
            {previewUrl?.length > 0 &&
              previewUrl.map((url, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    maxWidth: "500px",

                    marginBottom: "5px", // Centered and spaced

                    borderRadius: "8px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  {allFiles?.[idx]?.type?.startsWith("image/") ? <Image src={url} width={40} height={40} style={{ objectFit: "cover" }} preview={true} /> : <FaRegFilePdf style={{ color: "red", marginRight: "5px", fontSize: "22px" }} />}
                  <div style={{ flex: 1, marginLeft: "15px" }}>
                    <Text strong style={{ fontSize: "13px", display: "block" }}>
                      {fileText[idx]?.name}
                    </Text>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Size: {fileText[idx]?.size}
                    </Text>
                  </div>
                  <Checkbox
                    checked={selectedFiles.includes(idx)}
                    onChange={(e) => {
                      setSelectedFiles((prev) => (e.target.checked ? [...prev, idx] : prev.filter((i) => i !== idx)));
                    }}
                  />
                </div>
              ))}
          </div>
        )}
      </Modal>
    </>
  );
};

export { EmailFile };
